import http from '@/api/common'

export default {
  // Command
  upsertBusiness (data) {
    return http.post('c/Business/Upsert', data)
  },
  upsertBusinessUser (data) {
    return http.post('c/Business/ModifyUsers', data)
  },
  upsertBusinessNote (data) {
    return http.post('c/Business/UpsertNote', data)
  },
  upsertBusinessDocument (data, config) {
    return http.post('Business/AddDocument', data, config)
  },
  upsertBusinessInfo (data) {
    return http.post('c/Business/UpsertInfo', data)
  },
  upsertBusinessBilling (data) {
    return http.post('c/Business/UpsertBilling', data)
  },
  upsertBusinessDiscount (data) {
    return http.post('c/Business/UpsertDiscount', data)
  },
  resetUserPassword (data) {
    return http.post('c/Business/ResetPassword', data)
  },
  getDownloadToken (data) {
    return http.post(`c/User/GetDownloadToken`, data)
  },
  // Query
  getBusinesses (data) {
    return http.get('BusinessQuery/Registered', data)
  },
  getBusinessLocation (sid) {
    return http.get(`BusinessQuery/Location?key=${sid}`)
  },
  getBusinessInfo (sid) {
    return http.get(`BusinessQuery/Info?key=${sid}`)
  },
  getBusinessUsers (sid) {
    return http.get(`BusinessQuery/Users?key=${sid}`)
  },
  getBusinessNotes (sid) {
    return http.get(`BusinessQuery/Notes?key=${sid}`)
  },
  getBusinessBilling (sid) {
    return http.get(`BusinessQuery/Billing?key=${sid}`)
  },
  getBusinessDiscounts ({ sid, type, other }) {
    return http.get(`BusinessQuery/Discounts?key=${sid}&type=${type}&other=${other}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/business.js